import { render } from "./dmedicalrecords.vue?vue&type=template&id=71f03095"
import script from "./dmedicalrecords.vue?vue&type=script&lang=js"
export * from "./dmedicalrecords.vue?vue&type=script&lang=js"

import "./dmedicalrecords.vue?vue&type=style&index=0&id=71f03095&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__